import React from 'react';
import { List } from '@mui/material';
import NoAlertsDisplay from 'src/components/Alerts/NoAlertsDisplay';
import AlertListItem from 'src/components/Alerts/AlertListItem';

const AlertsContainer = ({ alerts, clickHandler, actionsComponent, isArchiving, isArchivedSection }) => {
  return (
    <>
      {alerts.length > 0 ? (
        <List
          disablePadding
          sx={{
            '& a': {
              color: 'text.secondary',
            },
          }}
        >
          {alerts.map((alert, index) => (
            <AlertListItem
              key={`${alert.id}+${alert.message}`}
              alert={alert}
              actionsComponent={actionsComponent}
              clickHandler={clickHandler}
              isArchiving={isArchiving}
              isLatest={index === 0 && !isArchivedSection}
            />
          ))}
        </List>
      ) : (
        <NoAlertsDisplay />
      )}
    </>
  );
};

export default AlertsContainer;
